import { render, staticRenderFns } from "./FreightTablesEmptyState.vue?vue&type=template&id=76ca84e8"
import script from "./FreightTablesEmptyState.vue?vue&type=script&lang=js"
export * from "./FreightTablesEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports